import { useTranslation } from '../i18n';
import type { SortSpec, SortKey, SortDir } from './CatalogFilters';

interface Option {
    key: SortKey;
    dir: SortDir;
    messageKey: string;
}

const OPTIONS: Option[] = [
    { key: 'changed', dir: 'desc', messageKey: 'catalogSort.changedDesc' },
    { key: 'recent', dir: 'desc', messageKey: 'catalogSort.recentDesc' },
    { key: 'name', dir: 'asc', messageKey: 'catalogSort.nameAsc' },
    { key: 'name', dir: 'desc', messageKey: 'catalogSort.nameDesc' },
    { key: 'author', dir: 'asc', messageKey: 'catalogSort.authorAsc' },
    { key: 'source', dir: 'asc', messageKey: 'catalogSort.source' },
    { key: 'kind', dir: 'asc', messageKey: 'catalogSort.kind' },
];

const VALUE_SEP = '|';

function specToValue(spec: SortSpec): string {
    return `${spec.key}${VALUE_SEP}${spec.dir}`;
}

function valueToSpec(value: string): SortSpec {
    const [key, dir] = value.split(VALUE_SEP) as [SortKey, SortDir];
    return { key, dir };
}

export function SortDropdown({ value, onChange }: { value: SortSpec; onChange: (next: SortSpec) => void }) {
    const t = useTranslation();
    return (
        <select
            value={specToValue(value)}
            onChange={(e) => onChange(valueToSpec((e.target as HTMLSelectElement).value))}
            class="rounded-md border border-surface-2 bg-surface-1 px-2 py-1 text-xs text-fg-primary focus:border-accent focus:outline-none"
            title={t('catalogFilters.search')}
        >
            {OPTIONS.map((opt) => (
                <option key={specToValue(opt)} value={specToValue(opt)}>
                    {t(opt.messageKey)}
                </option>
            ))}
        </select>
    );
}
